<template>
  <!--页面加载动画-->
  <div class="letter-box">
    <span class="defaultTxt" @click="showLayer=true">
      {{defaultTxt || "请选择"}}
      <i class="iconfont iconzhankai-xianxing"></i>
    </span>
    <div class="letter-layer-box" v-show="showLayer">
      <div class="top-btn">
        <span class="btn btn-cancle" @click="handleCancle">取消</span>
        <span class="btn btn-sure" @click="handleSure">确认</span>
      </div>
      <div class="mainContent">
        <div class="letter-content">
          <template v-for="(item,key,i) in allData">
            <ul class="mainLi">
                <li class="notCheck">{{key}}</li>
                <template v-for="(data,n) in item">
                  <li @click="trigger(key,n,data)">
                    <span class="name">{{data.name}}</span>
                    <span :class='[{active:data.path==radioData},"check check-radio"]' v-if="type==1"></span>
                    <span :class='[{active:data.active},"check check-checkbox"]' v-else-if="type==2"></span>
                  </li>
                </template>
            </ul>
          </template>
        </div>
        <div class="initials">
          <template v-for="(item,i) in letterArr">
            <div>
              {{item}}
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      allData: Array, //选择元素
      showLayer: false, //是否弹窗选择框
      letterArr: [], //首字母数组
      defaultTxt: "", //是否弹窗选择框
      checkValue: null, //选择结果
      radioData:'',//单选结果
      checkboxData:'',//多选结果
      type:2,
    };
  },
  props: ["selectData", "proId"],
  mounted() {
    if(this.selectData.elementItems && this.selectData.elementItems.length>0){
      this.initDatas(this.selectData.elementItems);
    }
    if(this.selectData.elementValue){
      this.multiplex();
    }
    console.log('旅游地区',this.allData);
  },
  methods: {
    // 选择处理数据
    trigger(key,index,data){
      if(this.type==1){
        this.radioData=`${key}[${index}]`;
      }else if(this.type==2){
        data.active=!data.active
        this.$set(this.allData[key],index,data)
      }
      console.log('旅游地区',this.allData);
    },
    // 确认
    handleSure(index) {
      this.getValue();
      this.getResult();
      this.showLayer = false;
    },
    //取消
    handleCancle() {
      this.showLayer = false; 
    },
    initDatas(data) {
      let result = {};
      let letterArr=[];
      data.forEach(item=>{
        if(!result[item.initial]){
          result[item.initial]=new Array()
        }
        item.active=false;
        item.path=`${item.initial}[${result[item.initial].length}]`;
        result[item.initial].push(item)
      })
      this.allData=result
      for(var k in result){
        letterArr.push(k)
      }
      this.letterArr=letterArr;
    },
    multiplex(){
      let value=this.selectData.elementValue;
      if(this.type==1){
        this.radioData=value.path;
        this.defaultTxt=value.name;
        this.checkValue=value
      }else if(this.type==2 && _.isArray(value)){
        let txt="";
        value.forEach((item,i)=>{
          txt+=i==0?item.name:','+item.name;
          _.set(this.allData,item.path+'.active',true)
        })
        this.defaultTxt=txt;
        this.checkValue=value
      }
    },
    getValue(){
      let value;
      if(this.type==1){
        value = _.get(this.allData,this.radioData,'');
        this.defaultTxt=value.name;
        this.checkValue=value
      }else if(this.type==2){
        value=[];
        _.forIn(this.allData, function(item, key) {
          item.map(child=>{
            if(child.active){
              value.push(child)
            }
          })
        });
        this.checkValue=value;
        var txt='';
        value.forEach((item,i)=>{
          txt+=i==0?item.name:','+item.name;
        })
        this.defaultTxt=txt;
      }
      console.log(this.checkValue)
    },
    getResult() {
      //选择后回调到父组件
      let value = this.checkValue;
      console.log(value)
      this.$emit("selected", {
        type:1,
        item:this.selectData,
        value: value
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.letter-box {
  width: 100%;
  height: 100%;
  .iconzhankai-xianxing {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    color: #999;
    font-size: 36px;
  }
  .defaultTxt {
  width: 100%;
  height: 100%;
  line-height: 40px;
  font-size: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 50px;
  display: inline-block;
}
.letter-layer-box {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  background-color: #fff;
  padding-top: 40px;
  .top-btn {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 40px;
    z-index: 3;
    background-color: #eeeeee;
  }
  .btn {
    line-height: 40px;
    padding: 0 20px;
  }
  .btn-cancle {
    float: left;
  }
  .btn-sure {
    float: right;
    color: #0084ff;
  }
  .mainContent {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 2;
    background-color: #fff;
    padding-right: 100px;
    padding-top: 40px;
  }
  .letter-content{
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    padding-left: 30px;
  }
  .mainLi >li{
    position: relative;
      margin-left: 10px;
      width: 82%;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      text-align: left;
      border-bottom: 1px solid #eee;
      padding: 0 10px;
  }
  .mainLi .notCheck{
    width: 85%;
    margin-left: 0;
    height: 24px;
    line-height: 24px;
    font-size: 18px;
    border-bottom: none;
    padding-left: 10px;
    color: #fff;
    background-color: #c3c3c3;
  }
  .initials{
    position: absolute;
    width: 100px;
    right: 0;
    top: 40px;
    height: 100%;
    div{
      color: #666;
      line-height: 20px;
      font-size: 16px;
    }
  }
  .check{
    position: absolute;
    right: 10px;
    top: 50%;
    margin-top: -9px;
  }
  .check-radio{
    width: 20px;
    height: 20px;
    border: 1px solid #e5e5e5;
    background-color: #fff;
    border-radius: 50%;
    &.active{
      background-color: #0084ff;
      &:before{
        content: "\E623";
        font-family: "iconfont" !important;
        display: inline-block;
        position:absolute;
        left:0;
        top:0;
        width: 18px;
        height: 18px;
        font-size: 12px;
        color: #fff;
        line-height: 16px;
        text-align: center;
        animation: showCheck 1s;
      }
    }
  }
  .check-checkbox{
    width: 20px;
    height: 20px;
    border: 1px solid #e5e5e5;
    background-color: #fff;
    border-radius: 3px;
    &.active{
      background-color: #0084ff;
      &:before{
        content: "\E64E";
        font-family: "iconfont" !important;
        display: inline-block;
        position:absolute;
        left:0;
        top:0;
        width: 18px;
        height: 18px;
        font-size: 12px;
        color: #fff;
        line-height: 18px;
        text-align: center;
        animation: showCheck 1s;
      }
    }
  }
}
}
@keyframes showCheck
{
  0%   {transform: scale3d(.3,.3,.3); opacity: 0;}
  20%  {transform: scale3d(1.1,1.1,1.1); opacity: 1;}
  40%  {transform: scale3d(.9,.9,.9); opacity: 1;}
  60% {transform: scale3d(1.03,1.03,1.03); opacity: 1;}
  80% {transform: scale3d(0.97,0.97,0.97); opacity: 1;}
  100% {transform: scale3d(1,1,1); opacity: 1;}
}

</style>